import { apiFetch } from './client';

export async function fetchSubcategories() {
    try {
        // Prima tenta l'endpoint /api/menu/snapshot che restituisce tutto in un colpo solo
        const res = await apiFetch('/api/menu/snapshot');
        if (res.ok) {
            const data = await res.json();
            return data.subcategories; // Restituisce solo le sottocategorie
        }

        // Fallback: endpoint originale
        const fallback = await apiFetch('/api/subcategories');
        if (!fallback.ok) throw new Error('Errore caricamento sottocategorie');
        return fallback.json();
    } catch (error) {
        console.error('Errore caricamento sottocategorie:', error);
        throw error;
    }
}

export async function createSubcategory(data: any) {
    const res = await apiFetch('/api/subcategories', { method: 'POST', body: JSON.stringify(data) });
    if (!res.ok) throw new Error('Errore creazione sottocategoria');
    return res.json();
}

export async function updateSubcategory(id: number | string, data: any) {
    const res = await apiFetch(`/api/subcategories/${id}`, { method: 'PUT', body: JSON.stringify(data) });
    if (!res.ok) throw new Error('Errore aggiornamento sottocategoria');
    return res.json();
}

export async function deleteSubcategory(id: number | string) {
    const res = await apiFetch(`/api/subcategories/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Errore eliminazione sottocategoria');
    return true;
}

export async function reorderSubcategories(items: { id: number | string; sortOrder: number }[]) {
    const res = await apiFetch('/api/subcategories/reorder', {
        method: 'PUT',
        body: JSON.stringify(items)
    });
    if (!res.ok) throw new Error('Errore riordino sottocategorie');
    return true;
}
